import { getGridBackgroundStyles } from '@/utils';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { getImageCardUrl } from '../../../../components/FileImageCard/utils';

export function FastCheckoutImage() {
	const image = useSelector(
		({ editor }) =>
			editor.images.find(item => item.id === editor.selectedImage) || {}
	);
	const imageUrl = getImageCardUrl({ pipeline: image });

	return (
		<Box
			sx={{
				mt: 2,
				py: 1,
				backgroundColor: 'neutral.150',
				borderRadius: '4px',
				display: 'flex',
				justifyContent: 'center'
			}}
		>
			<Box
				sx={{
					width: 360,
					height: 360,
					...getGridBackgroundStyles(10),
					border: '2px solid',
					borderColor: 'divider',
					borderRadius: '4px',
					overflow: 'hidden'
				}}
			>
				<Box
					sx={{
						backgroundImage: imageUrl ? `url(${imageUrl})` : 'none',
						backgroundSize: 'cover',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						width: '100%',
						height: '100%'
					}}
				/>
			</Box>
		</Box>
	);
}
